import { CustomFieldValidator } from '@backstage/plugin-scaffolder-react';

import { DaasComponentPickerConfig } from './types';

export const daasComponentPickerValidation: CustomFieldValidator<
  DaasComponentPickerConfig
> = (value, validation) => {
  if (!value) {
    validation.addError('Please select a DaaS Component');
    return;
  }
  if (!value.type) {
    validation.addError('Please select a DaaS Component type');
    return;
  }
  if (!value.entityRef) {
    validation.addError('Please select a DaaS Component');
    return;
  }

  if (value.relationsValidation) {
    if (value.dependencyOf && value.dependencyOf.length !== 0) {
      validation.addError(
        `The selected component has existing dependencies: ${value.dependencyOf?.join(
          ', ',
        )}. Please delete them before proceeding.`,
      );
    }
  }
};
